import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@snsw-gel/react";
import ServiceNSWLogo from "../assets/serviceNSWLogo";
import { BONDS_HOME } from "./RequireProduct";
import styles from "./NoAccess.module.css";

interface NoAccessProps {
  /** denied: not in the access list; failed: lookup errored; disabled: feature off */
  status: "denied" | "failed" | "disabled";
}

/**
 * NoAccess — the landing surface for someone who reached an Athena route
 * without an Athena grant. The grant model lives in the Athena proxy's
 * access list (ADR 0004); this page just explains the miss and offers a way
 * back to the product they can use.
 */
export const NoAccess: React.FC<NoAccessProps> = ({ status }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <ServiceNSWLogo w={"123"} h={"63"} />
      </div>
      <main className={styles.content}>
        <h1 className={styles.title}>Athena is not available for your account yet</h1>
        <p className={styles.body}>
          {status === "failed"
            ? "We could not check your access just now. Please try again in a moment."
            : "Access to Athena is managed for your service. Speak to your Sage product owner to request it."}
        </p>
        <div className={styles.actions}>
          <Button onClick={() => navigate(BONDS_HOME)}>Back to Sage chat</Button>
        </div>
      </main>
    </div>
  );
};
